import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'jhi-column-filter-checklist',
    template: `
        <form #f='ngForm'>
            <div class="form-check" *ngFor="let option of filter.options | async">
                <input class="form-check-input" type="checkbox" [(ngModel)]="option.checked"
                        id="check-{{option.id}}" name="check-{{option.id}}">
                <label class="form-check-label" for="check-{{option.id}}">
                    @if (filter.translate) {
                        {{ option.name | translate }}
                    } @else {
                        {{ option.name }}
                    }
                </label>
            </div>
            <br/>
            <div class="footer text-center"><br>
                <button type="submit" class="btn btn-primary btn-sm me-1" [disabled]="!f.valid" (click)="apply(f)">{{ 'apply' | translate }}</button>
                <button class="btn btn-secondary btn-sm" (click)="reset(f)">{{ 'reset' | translate }}</button>
            </div>
        </form>
    `
})
export class ColumnFilterChecklistComponent implements OnInit {
    @Input() filter: any;

    @Output() onApply = new EventEmitter();
    @Output() onReset = new EventEmitter();

    ngOnInit(): void {
    }

    apply(form) {
        if (!form.valid) {
            return;
        }
        this.onApply.emit();
    }

    reset(form) {
        form.reset();
        this.onReset.emit();
    }
}
